var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Tags",class:_vm.classList},_vm._l((_vm.visibleTags),function(tag){return _c('Tag',{key:tag.name,attrs:{"label":tag.name,"type":tag.type,"slug":tag.slug,"compact":_vm.compact}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }